import {
  MatButtonModule,
  MatStepperModule,
  MatCheckboxModule,
  MatSelectModule,
  MatInputModule,
  MatIconModule,
  MatDialogModule,
  MatToolbarModule
  ,
  MatTabsModule,
  MatSnackBarModule,
  MatExpansionModule,
  MatMenuModule,
  MatCardModule,
  MatButtonToggleModule,
  MatProgressSpinnerModule,
  MatTooltipModule
} from '@angular/material';
import {FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';


import {
  NgModule,
  ApplicationRef
} from '@angular/core';
import {ImageBgDirective} from "../component/shared/image-components/image-bg.directive";
import {PersianDatePickerComponent} from "../component/shared/date-picker/date-picker.component";
import {PersianDatePickerV2Component} from "../component/shared/date-picker-v2/date-picker-v2.component";
import {SimpleDatePickerComponent} from "../component/shared/simple-date-picker/simple-date-picker.component";
import {RWDatePickerComponent} from "../component/shared/rw-date-picker/rw-date-picker.component";

import {DpDatePickerModule} from 'ng2-jalali-date-picker';
import {ToPricePipe} from "../pipes/price.pipe";
import {ToPersianNumberPipe} from "../pipes/price.pipe";
import {WaitSpinnerComponent} from "../component/shared/wait-spinner/wait-spinner.component";
import {TimePickerComponent} from "../component/shared/time-picker/time-picker.component";
import {ToPersianDatePipe, FromNowPipe} from "../pipes/persian-date.pipe";
import {ToPersianTimePipe} from "../pipes/persian-date.pipe";
import {SharingFormComponent} from "../component/shared/sharing-form/sharing-form.component";
import {ClipboardModule} from 'ngx-clipboard';
import {LongTextComponent} from "../component/shared/long-text/long-text.component";
import {ReadMoreDirective} from "../../../node_modules/ngx-read-more/src/read-more.directive";
import {DialogFormComponent} from "../component/shared/dialog-form/dialog-form.component";
import {ToPersianLongDatePipe} from "../pipes/persian-date.pipe";
import {LoadingModule} from 'ngx-loading';
import {TranslateModule} from 'ng2-translate';
import {DialogTermsAndConditionsComponent} from "../component/shared/dialog-termsAndConditions/dialog-termsAndConditions.component";
import {ToPersianMonthPipe} from "../pipes/persian-date.pipe";
import {PersonInfoComponent} from "../component/person-info/personInfo.component";
import {DialogServantProfileComponent} from "../component/servant-profile/dialog-servant-profile.component";
import {LoginFormNoPassComponent} from "../component/login-form-nopass/login-form-nopass.component";
import {LoginComponent} from "../login/login.component";
import {RegisterComponent} from "../register/register.component";
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [TranslateModule, LoadingModule, ClipboardModule, CommonModule, FormsModule, MatMenuModule, MatButtonModule, MatStepperModule, MatCheckboxModule, MatSelectModule, MatInputModule
    , MatIconModule, MatDialogModule, MatTabsModule, MatSnackBarModule, MatToolbarModule, MatCardModule, MatButtonToggleModule, MatProgressSpinnerModule, MatExpansionModule, DpDatePickerModule,RouterModule],
  exports: [LoadingModule, LongTextComponent, DialogFormComponent, SharingFormComponent, ToPricePipe, ToPersianNumberPipe, ToPersianDatePipe, FromNowPipe, ToPersianLongDatePipe, ToPersianTimePipe, TimePickerComponent, WaitSpinnerComponent,ToPersianMonthPipe,
    ToPricePipe, MatExpansionModule, ToPersianNumberPipe, MatMenuModule, MatButtonModule, MatCheckboxModule, MatSelectModule, MatInputModule, MatTooltipModule
    , MatIconModule, MatDialogModule, MatTabsModule, MatSnackBarModule, MatStepperModule, MatToolbarModule, MatCardModule, MatButtonToggleModule, ImageBgDirective, MatProgressSpinnerModule, MatTooltipModule, DpDatePickerModule, PersianDatePickerComponent, PersianDatePickerV2Component,SimpleDatePickerComponent,RWDatePickerComponent,PersonInfoComponent,LoginFormNoPassComponent,LoginComponent,RegisterComponent],
  declarations: [ReadMoreDirective, LongTextComponent, DialogFormComponent, SharingFormComponent, ImageBgDirective, PersianDatePickerComponent, PersianDatePickerV2Component,SimpleDatePickerComponent, ToPricePipe, ToPersianNumberPipe, ToPersianDatePipe, FromNowPipe, ToPersianLongDatePipe, ToPersianTimePipe,ToPersianMonthPipe, WaitSpinnerComponent, TimePickerComponent, DialogTermsAndConditionsComponent,RWDatePickerComponent,PersonInfoComponent,DialogServantProfileComponent,LoginFormNoPassComponent,LoginComponent,RegisterComponent],
  entryComponents: [DialogTermsAndConditionsComponent,DialogServantProfileComponent,LoginFormNoPassComponent,LoginComponent]
})
export class ShareModule {
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/share/share.module.ts